var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group"},[_c('input',{attrs:{"type":_vm.type},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}}),_c('label',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }